import { Injectable } from "@angular/core";
import { AccountAppCommand, AuthTransactionResponse } from "@fabric-types/app-account";
import { DialogService } from "@obg/mat.ui.core";
import { DocumentRef } from "@obg/ngx.global.evo";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";

import { CafFaceAuthenticatorContainer } from "./caf-face-authenticator.container";

@Injectable({ providedIn: "root" })
export class CAFAuthenticatorService {
	constructor(
		private dialogService: DialogService,
		private documentRef: DocumentRef
	) {}

	openCafAuthenticator$(cpfNumber?: string, closeCallback?: () => void): Observable<string | undefined> {
		const dialogRef = this.dialogService.openComponent(CafFaceAuthenticatorContainer, {
			data: {
				cpf: cpfNumber,
			},
		});

		const unlisten = this.documentRef.obgEventBus.listen(
			AccountAppCommand.FaceAuthenticationSuccessful,
			(payload: AuthTransactionResponse) => {
				if (payload?.isValid && payload?.authenticationToken) {
					dialogRef.close(payload.authenticationToken);
				}
			}
		);

		return dialogRef.afterClosed().pipe(
			finalize(() => {
				dialogRef.close();
				closeCallback?.();
				unlisten();
			})
		);
	}
}
